import { render, staticRenderFns } from "./activityDownload.vue?vue&type=template&id=10854c04"
import script from "./activityDownload.vue?vue&type=script&lang=js"
export * from "./activityDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports